import {DetailColumns, DetailPane, name} from '@management-ui/core';
import {Box} from '@mui/material';
import React, {useCallback, useEffect, useState} from 'react';
import LocationList from '../../components/LocationList';
import Controls from '../../components/Slider/Controls';
import Header from '../../components/Slider/Header';
import What from './JobDetails';
import NewEndUserLocation from './NewEndUserLocation';
import NewOrExistingContact from './NewOrExistingContact';
import NewOrExistingEndUser from './NewOrExistingEndUser';
import Who from './Who';
import withContact from './withContact';

const Slide = ({session, contact, onNext, goBackWithoutContact}) => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (contact) {
      setLocations(contact.locations.map(location => ({...location, type: location.type?.name ?? 'End User'})));
    }
  }, [contact]);

  const handleBack = useCallback(() => {
    goBackWithoutContact(
      session.selectedContact ?
        {type: NewOrExistingEndUser.type, id: NewOrExistingEndUser.type} :
        (
          session.selectedCompany ?
            {type: NewOrExistingContact.type, id: NewOrExistingContact.type} :
            {type: Who.type, id: Who.type}
        )
    )
  }, [session, goBackWithoutContact]);

  return (
    <>
      <Header>End User Locations</Header>
      <DetailColumns columns={[

        <DetailPane
          title="Core Details"
          details={[
            {title: 'Name', value: contact ? name(contact) : '-'},
            {title: 'Job Title', value: contact?.position ?? '-'}
          ]}
        />,


        <DetailPane
          title="Contact Details"
          details={[
            {
              title: 'Email Address',
              value: contact?.email ?? '-',
              link: contact?.email ? `mailto:${contact.email}` : null
            },
            {title: 'Telephone Number', value: contact?.mobile ?? '-'},
            {title: 'Mobile Number', value: contact?.phone ?? '-'}
          ]}
        />,

      ]}/>
      <Box marginTop={2}>
        <LocationList
          locations={locations}
          layout="wide"
          addNew={{props: {}, type: ''}}
          onSelect={(selected) => {
            if (Object.keys(selected) < 1) {
              onNext({type: NewEndUserLocation.type, id: NewEndUserLocation.type});
            }
          }}
        />
      </Box>
      <Controls
        onBack={handleBack}
        onNext={() => onNext({type: What.type, id: What.type})}
        nextLabel="Continue to Job Details"
      />
    </>
  );
};

const EndUserLocations = withContact(Slide, true);

EndUserLocations.type = 'END_USER_LOCATIONS';

export default EndUserLocations;
